module.exports = __webpack_public_path__ + "img/enzo.b3ad93c3.jpg";